import * as React from 'react';
import {isRequired} from '../../util/validators';
import FieldFormControl from '../FieldFormControl';
import {Col, ControlLabel, FormGroup, Row} from 'react-bootstrap';
import { Field } from 'redux-form';

interface INameFieldProps {
  baseName: string;
  noSidePaddings: boolean;
}

class NameField extends React.Component<INameFieldProps> {
  public static defaultProps = {
    noSidePaddings: false,
  };

  public render() {
    const { baseName, noSidePaddings } = this.props;

    return (
      <div>
        <Col sm={6} className={noSidePaddings ? 'no-padding-left' : ''}>
          <Field
            type="text"
            placeholder="Prénom"
            name={baseName ? baseName + '.firstName' : 'firstName'}
            component={FieldFormControl}
            validate={[ isRequired ]}
          />
        </Col>
        <Col sm={6} className={noSidePaddings ? 'no-padding-right' : ''}>
          <Field
            type="text"
            placeholder="Nom"
            name={baseName ? baseName + '.lastName' : 'lastName'}
            component={FieldFormControl}
            validate={[ isRequired ]}
          />
        </Col>
      </div>
    );
  }
}

export default NameField;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/NameField/index.tsx